export const environment = {
    production: false,
    Url: 'http://data.supertaptap.com:83/dev-ws-reportesred/reports.svc/',
    logsUrl: 'https://api-logs.dev.supertaptap.com/ApisLogs/'
  };
  